
export default class Request {

  private dynamicHeaders?: () => Record<string, string>
  private headers: Record<string, string> | undefined = undefined
  private onResponse?: (response: Response) => void

  constructor(
    headers?: Record<string, string>,
    dynamicHeaders?: () => Record<string, string>,
    onResponse?: (response: Response) => void
  ) {
    this.headers = headers
    this.dynamicHeaders = dynamicHeaders
    this.onResponse = onResponse
  }

  updateHeaders(headers: Record<string, string>) {
    this.headers = headers
  }

  private resolveHeaders(): Record<string, string> {
    const dynamic = this.dynamicHeaders?.() || {}
    return { ...this.headers, ...dynamic }
  }

  //Call completion on response if we have it
  private notifyResponse(response: Response) {
    if (!this.onResponse) return
    try {
      this.onResponse(response)
    } catch (err) {
      console.log('Response listener error: ', err)
    }
  }

  async get<T>(path: string, options?: RequestInit): Promise<T> {
    const response = await fetch(path, {
      headers: this.resolveHeaders(),
      ...options
    })

    //Check for Response completion
    this.notifyResponse(response)

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP ${response.status}: ${errorText}`);
    }

    return response.json();
  }

  async post<T>(path: string, payload: any): Promise<T> {
    const response = await fetch(path, {
      headers: { ...this.resolveHeaders(), ...{ 'Content-Type': 'application/json' } }  ,
      method: 'POST',
      body: JSON.stringify(payload),
    })

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP ${response.status}: ${errorText}`);
    }

    return response.json();
  }

  async delete(path: string): Promise<any> {
    const response = await fetch(path, {
      headers: this.resolveHeaders()  ,
      method: 'DELETE',
    })

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP ${response.status}: ${errorText}`);
    }

    return response;
  }

}